import { DateTime } from "luxon";

export type ApiKeyType = {
  createdAt: Date;
  key: string;
  description: string;
};

export class ApiKey {
  date: string;
  description: string;
  key: string;
  constructor(apiKey: ApiKeyType) {
    this.date = DateTime.fromJSDate(apiKey.createdAt).toLocaleString(
      DateTime.DATE_MED
    );
    this.description = apiKey.description;
    this.key = apiKey.key;
  }
}
